'use strict';

const init = () => {
  // add 'touch' class to <body> if touch device is detected
  if (isTouchDevice()) {
    document.body.classList.add('touch');
  }
}

const isTouchDevice = () => {
  return (('ontouchstart' in window) ||
    (navigator.maxTouchPoints > 0) ||
    (navigator.msMaxTouchPoints > 0));
}

export default {init}
